import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import MdCropSquare from 'react-icons/lib/md/crop-square'

export default class Text extends React.Component {
  static propTypes = {
    value: PropTypes.bool
  }

  state = {}

  render() {
    if (!this.props.value) {
      return (
        <span className={styles.pending}>
          <MdCropSquare />
        </span>
      )
    }
    return (
      <span className={styles.container}>
        <input type="checkbox" readOnly checked={this.props.value} />
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Show/Checkbox/index.js